import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';
import { PasswordRegex } from '../../../../shared/constants';

export function getAddAdminUserFormValidation(t: TFunction) {
  return yup.object({
    firstname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.firstnameRequired')),
    lastname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.lastnameRequired')),
    email: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .email(t('formikValidation.emailCorrect'))
      .required(t('formikValidation.emailRequired')),
    password: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.passwordRequired'))
      .min(8, t('formikValidation.passwordMin'))
      .matches(PasswordRegex, t('formikValidation.passwordPattern')),
    confirmPassword: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .oneOf([yup.ref('password')], t('formikValidation.confirmPasswordMatch')),
    role: yup.object().required(t('formikValidation.roleRequired')),
  });
}

export function getEditAdminUserFormValidation(t: TFunction) {
  return yup.object({
    firstname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.firstnameRequired')),
    lastname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.lastnameRequired')),
    email: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .email(t('formikValidation.emailCorrect'))
      .required(t('formikValidation.emailRequired')),
    role: yup.object().required(t('formikValidation.roleRequired')),
  });
}
